import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReactSimpleDropdown, {
  DropdownTrigger,
  DropdownContent,
} from 'react-simple-dropdown';
import { HotKeys } from 'react-hotkeys';
import onClickOutside from 'react-onclickoutside';

import * as actions from 'store/services/testSets/actions';
import * as selectors from 'store/services/testSets/selectors';
import { testSetType, testSetsPaginationOptionsType } from 'types';
import EmptyView from 'components/EmptyView';
import Pagination from 'components/Pagination';
import TestSetsList from './components/TestSetsList';

import './style.scss';

const keyMap = {
  leave: ['esc', 'escape'],
};

export class TestSetsIntentsSelector extends Component {
  static propTypes = {
    count: PropTypes.number.isRequired,
    deselectTestSet: PropTypes.func.isRequired,
    getTestSets: PropTypes.func.isRequired,
    paginationOptions: testSetsPaginationOptionsType.isRequired,
    selectedTestSet: testSetType.isRequired,
    selectTestSet: PropTypes.func.isRequired,
    testSets: PropTypes.arrayOf(testSetType).isRequired,
    toggleTestSetsList: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
  };

  static defaultProps = {
    isActive: false,
  };

  state = {
    isActive: this.props.isActive,
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      isActive: nextProps.isActive,
    });
  }

  handleCloseDropdown = () => {
    this.setState(
      {
        isActive: false,
      },
      () => {
        this.props.toggleTestSetsList(false);
      },
    );
  };

  handleSelectTestSet = testSet => {
    this.props.selectTestSet(testSet);

    this.handleCloseDropdown();
  };

  keyHandlers = {
    leave: () => {
      // TODO: replace this with refs
      const tooltipElement = document.querySelectorAll(
        '.__react_component_tooltip.show',
      )[0];
      if (!tooltipElement) {
        this.handleCloseDropdown();
      }
    },
  };

  handleClickOutside = () => {
    if (this.state.isActive) {
      this.handleCloseDropdown();
    }
  };

  handleToggle = () => {
    this.setState(
      ({ isActive }) => ({
        isActive: !isActive,
      }),
      () => {
        this.props.toggleTestSetsList(this.state.isActive);
      },
    );
  };

  handleDeselectTestSet = () => {
    this.props.deselectTestSet();
  };

  handleRef = el => {
    this.dropdown = el;
  };

  renderList() {
    const { testSets, selectedTestSet } = this.props;

    if (this.state.isActive && testSets.length > 0) {
      return (
        <TestSetsList
          selectedTestSet={selectedTestSet}
          selectTestSet={this.handleSelectTestSet}
          testSets={testSets}
        />
      );
    }

    return (
      <EmptyView>
        <p>You have no Test Sets</p>
      </EmptyView>
    );
  }

  renderPagination() {
    const { testSets, paginationOptions, count, getTestSets } = this.props;

    if (testSets.length > 0) {
      return (
        <Pagination
          count={count}
          getItems={getTestSets}
          paginationOptions={paginationOptions}
          styleName="pagination"
        />
      );
    }

    return null;
  }

  render() {
    return (
      <HotKeys
        focused
        attach={window}
        handlers={this.keyHandlers}
        keyMap={keyMap}
      >
        <ReactSimpleDropdown
          ref={this.handleRef}
          active={this.state.isActive}
          styleName="dropdown"
        >
          <DropdownTrigger styleName="trigger" onClick={this.handleToggle}>
            <span className="icon-test-set" />
            <span>Test Sets</span>
            <span
              className="icon-triangle-arrow-down"
              data-test="test-sets-dropdown-arrow"
              styleName="triangle-icon"
            />
          </DropdownTrigger>

          <DropdownContent>
            {this.renderList()}

            {this.renderPagination()}
          </DropdownContent>
        </ReactSimpleDropdown>
      </HotKeys>
    );
  }
}

const mapStateToProps = state => ({
  paginationOptions: selectors.getPaginationOptions(state),
  count: selectors.getTestSetsListCount(state),
  testSets: selectors.getTestSetsList(state),
  selectedTestSet: selectors.getTestSet(state),
});

const mapDispatchToProps = dispatch => ({
  getTestSets: bindActionCreators(actions.getTestSetsList, dispatch),
  selectTestSet: bindActionCreators(actions.selectTestSet, dispatch),
  deselectTestSet: bindActionCreators(actions.deselectTestSet, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(onClickOutside(TestSetsIntentsSelector));
